import {
  AirPFPurchaseServices,
  CartServices,
  getObjectKeysAsObject,
} from "@hopper-b2b/checkout";
import { trackUberPaymentPf } from "./trackUberPaymentPf";

export const Services = {
  ...CartServices,
  ...AirPFPurchaseServices,
  trackUberPaymentPf,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
